// Import everything from autoload folder
import './autoload/_bootstrap.js'; import './autoload/ada-compliance.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import './plugins/google-map';
import 'jquery-match-height';
import LazyLoad from 'vanilla-lazyload';
import objectFitImages from 'object-fit-images';
import { Fancybox } from '@fancyapps/ui';
import barba from '@barba/core';
// import ScrollOut from 'scroll-out';

/* global Swiper */
/* global ajax_object */

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * BarbsJS init
   */
  const $body = $(document.body);
  if ($body.data('barba') === 'wrapper') {
    barba.init({
      timeout: 10000,
      transitions: [
        {
          name: 'basic',
          /*enter: function enter() {
            // Init LazyLoad (for ignore .no-lazyload)
            //lazyLoadInit();
          },*/
          beforeEnter: function beforeEnter() {
            $('html, body').animate({ scrollTop: 0 }, 600);
          },
          after: function after() {
            let pageEdit = $(document).find('#bwp-main').data('edit');
            if (pageEdit) {
              $(document).find('#wp-admin-bar-edit > a').attr('href', pageEdit);
            }

            let $formWrapper = $('.form-wrapper');
            if ($formWrapper.length) {
              let formID = $formWrapper.attr('data-form-id');

              $.ajax({
                url: ajax_object.ajax_url,
                type: 'GET',
                data: {
                  form_id: formID,
                  action: 'get_form',
                },
              }).done(function (response) {
                $('.form-wrapper').html(response);

                setTimeout(function () {
                  $formWrapper.find('script').each((index, el) => {
                    window.eval($(el).text());
                  });
                }, 2000);
              });
            }

            // Update elements
            lazyLoadInit();
            slidersInit();
            resizeVideo();
          },
        },
      ],
      prevent: ({ el }) =>
        el.classList &&
        (el.classList.contains('ab-item') ||
          el.classList.contains('fancybox-image') ||
          el.hasAttribute('data-fancybox')),
    });
  }

  /**
   * Add fancybox to images
   * a[href$="jpg"], a[href$="png"], a[href$="gif"], a[href$="webp"]
   */
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"], a[href$="webp"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');

  Fancybox.bind('[data-fancybox], .fancybox, a[rel*="album"]');

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Override bootstrap submenu toggle
   */
  $('.navbar .menu-item-has-children').hover(function () {
    if ($(window).width() > 991) {
      $(this).toggleClass('show');
      alignMenuDropdown($(this).children('.dropdown-menu'));
    }
  });

  // Prevent dropdown menu opening out of window
  function alignMenuDropdown($dropdown) {
    if ($dropdown === undefined || !$dropdown.length) return false;
    $dropdown.toggleClass(
      'dropdown-menu-left',
      $dropdown.offset().left + $dropdown.width() > $(window).width()
    );
  }

  // Dropdown menu mobile toggle
  $('.js-dropdown-toggle').bind('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($(window).width() <= 991) {
      $(this).closest('.dropdown').toggleClass('show');
    }
  });

  // Tribe events calendar month click
  $(document).on('click', '.tribe-events-calendar-month__calendar-event', function (e) {
    let $this = $(this);
    let $tooltipTrigger = $this.find('a[data-js="tribe-events-tooltip"]');

    if ($tooltipTrigger.length) {
      $tooltipTrigger.trigger('click');
    }
  });

  // Modal focus issue fix
  $('.tribe-events-modal').on('hidden.bs.modal', function () {
    // Remove focus from the active element
    document.activeElement.blur();
  });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    // jQuery code goes here
  });

  // Apply scrolling classes on autoscroll
  $(window).trigger('scroll');

  // Play video
  $(document).on('click', '.js-play-video', function(e){
    e.preventDefault();
    e.stopPropagation();
    let $this = $(this);
    let $video = $(document).find($this.attr('href'));
    if ($video.length) {
      $video.addClass('is-triggered').prop('controls', true).get(0).play();
      $this.fadeOut();
    }
  });

  lazyLoadInit();
  slidersInit();
  scrollToAnchor();
  resizeVideo();
  tribeEvents();
  customEventFormCalc();
  customEventSubscribe();
  customEventFormLoader();

  if ($(document).find('form.c-event-form, .js-event-form-load').length) {
    bwpRefreshCsrfToken();
  }
}); // END of document ready

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  // Optimize home slider (mobile)
  setTimeout(() => {
    let $sliderPreview = $('#home-slider-preview');
    let $homeSlider = $('#home-slider');
    if (
      $(window).width() <= 768 &&
      $sliderPreview.length &&
      $homeSlider.length
    ) {
      $sliderPreview.hide();
      $homeSlider.show();
    }
  }, 1200);
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
let lastScrollTop = 0;
$(window).on('scroll', function () {
  // jQuery code goes here
  let st = $(this).scrollTop();
  $(document.body)
    .toggleClass('scrolling-up', st < lastScrollTop)
    .toggleClass('scrolling-down', st > lastScrollTop)
    .toggleClass('scrolling', st !== 0);
  if (st === 0) $('body').removeClass('scrolling-up scrolling-down');
  lastScrollTop = st;
});

/* Scrolling to anchor */
function scrollToAnchor() {
  // Anchor click scrolling
  let topOffset = $(window).width() > 991 ? 100 : 70;
  $(document).on('click', 'a[href^="#"]', function (e) {
    if (
      $(this).attr('href') !== '#' &&
      !$(this).hasClass('fancybox') &&
      !$(this).hasClass('js-play-video') &&
      $(this).attr('role') !== 'tab'
    ) {
      e.preventDefault();
      let $this = $(this);
      if ($($this.attr('href')).length) {
        $('html, body').animate(
          {
            scrollTop: $($this.attr('href')).offset().top - topOffset + 'px',
          },
          750,
          'swing'
        );
      } else if ($this.attr('href') === '#next') {
        let $sectionToScroll = $this.closest('section').next('section');

        if ($sectionToScroll.length) {
          $('html, body').animate(
            {
              scrollTop: $sectionToScroll.offset().top - topOffset + 'px',
            },
            750,
            'swing'
          );
        }
      }
    }
  });

  // On load *only* if we have anchor on the url
  if (window.location.hash) {
    // smooth scroll to the anchor id
    $('html, body').animate(
      {
        scrollTop: $(window.location.hash).offset().top - topOffset + 'px',
      },
      750,
      'swing'
    );
  }
}

/* Sliders init */
function slidersInit() {
  // Init Swiper
  if ($('.js-home-slider').length && typeof Swiper !== undefined) {
    new Swiper('.js-home-slider', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 3000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1500,
      spaceBetween: 0,
      slidesPerView: 1,
    });
  }

  // Init Media slider
  let $mediaSliders = $('.js-media-slider');
  if ($mediaSliders.length && typeof Swiper !== undefined) {
    $mediaSliders.each(function (i, el) {
      let $this = $(el);
      let $section = $this.closest('section');
      let slidesPerView = $this.data('slides') ?? 2.3;
      let defaults = {
        loop: false,
        speed: 1500,
        spaceBetween: 0,
        slidesPerView: 1.5,
        breakpoints: {
          768: {
            slidesPerView: parseFloat(slidesPerView),
          },
        },
      };

      let options = $this.data('options') ?? {};

      options.navigation = {
        prevEl: $section.find('.swiper-button-prev').get(0),
        nextEl: $section.find('.swiper-button-next').get(0),
      };

      new Swiper(el, { ...defaults, ...options });
    });
  }

  // Init Flexible Slider
  let $sliders = $('.js-slider');
  if ($sliders.length && typeof Swiper !== undefined) {
    $sliders.each(function (i, el) {
      let $this = $(el);
      let $section = $this.closest('.s-slider');
      let defaults = {
        loop: true,
        speed: 1500,
        spaceBetween: 0,
        slidesPerView: 2,
      };
      let options = $this.data('options') ?? {};

      if (options.autoplay) {
        options.autoplay = {
          pauseOnMouseEnter: true,
        };
      }

      if (options.navigation) {
        options.navigation = {
          prevEl: $section.find('.swiper-button-prev').get(0),
          nextEl: $section.find('.swiper-button-next').get(0),
        };
      }

      if (options.pagination) {
        options.pagination = {
          el: $section.find('.swiper-pagination').get(0),
          dynamicBullets: true,
          clickable: true,
        };
      }

      new Swiper(el, { ...defaults, ...options });
    });
  }
}

// LazyLoad
function lazyLoadInit() {
  // Init LazyLoad (for ignore .no-lazyload).
  let lazyLoadInstance = new LazyLoad({
    elements_selector: 'img[data-lazy-src],.pre-lazyload',
    data_src: 'lazy-src',
    data_srcset: 'lazy-srcset',
    data_sizes: 'lazy-sizes',
    skip_invisible: false,
    class_loading: 'lazyloading',
    class_loaded: 'lazyloaded',
  });

  // Add tracking on adding any new nodes to body to update lazyload for the new images (AJAX for example).
  window.addEventListener(
    'LazyLoad::Initialized',
    function () {
      // Get the instance and puts it in the lazyLoadInstance variable.
      if (window.MutationObserver) {
        let observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (typeof node.getElementsByTagName !== 'function') {
                return;
              }
              let images = node.getElementsByTagName('img');
              if (0 === images.length) {
                return;
              }
              lazyLoadInstance.update();
            });
          });
        });
        let b = document.getElementsByTagName('body')[0];
        let config = { childList: true, subtree: true };
        observer.observe(b, config);
      }
    },
    false
  );
}

// Tribe events override
function tribeEvents() {
  $(document).find('[data-js~="tribe-events-tooltip"]').off('blur focus mouseout mouseover');

  $(document).on('click', 'a[data-js="tribe-events-tooltip"]', function(e){
    e.preventDefault();
    e.stopPropagation();

    let $this = $(e.currentTarget);
    let modalId = $this.data('tooltip-content') + '-modal';
    let $modal = $(document).find(modalId);

    if ($modal.length) {
      $modal.modal('show');
    }
  });
}

// Custom events: CSRF token bootstrap.
//
// Event pages can be served from a full page cache, so no per-visitor value
// can be baked into that HTML. This AJAX call always runs fresh in the
// browser regardless of the HTML's cache status; the server mints a random
// token, echoes it back, and pairs it with a matching cookie (double-submit
// pattern) that a cross-origin request can't read or set.
function bwpRefreshCsrfToken() {
  return $.ajax({
    type: 'POST',
    url: ajax_object.ajax_url,
    cache: false,
    data: { action: 'bwp_csrf_token' }
  }).done(function(response){
    let token = response?.data?.token;
    if (token) {
      ajax_object.nonce = token;
      $(document).find('[name="subscribe_event_nonce"]').val(token);
    }
  });
}

// Custom event subscription
function customEventSubscribe() {
  const $eventForms = $(document).find('form.c-event-form');
  if (!$eventForms.length) return false;

  $eventForms.each(function(i, el) {
    let form_id = $(el).attr('id');
    if (!form_id.length) return false;

    $('#' + form_id).off('submit.bwpEvent').on('submit.bwpEvent', function(e){
      e.preventDefault();

      let $form = $(this);
      let $wrapper = $form.closest('.c-event-form__wrapper');

      // The overlay covers the submit button, but not a second Enter keypress,
      // so guard the whole round trip against a double subscription
      if ($form.data('bwpSubmitting')) return false;
      $form.data('bwpSubmitting', true);

      $wrapper.addClass('ajax-overlay--active');

      // Re-sync in case the tab was left open long enough for the cookie set
      // on page load to expire. On a failed refresh we still submit with
      // whatever token is currently in the field, so the server answers with
      // a readable message instead of the request silently hanging.
      bwpRefreshCsrfToken().always(function(){
        bwpSubmitEventForm($form, $wrapper);
      });
    });
  });
}

function bwpSubmitEventForm($form, $wrapper) {
  let formData = $form.serialize();

  $.ajax({
    type: 'POST',
    url: ajax_object.ajax_url,
    data: formData + '&action=subscribe_to_event',
    success: function(response){
      let data = response?.data;
      let message = data?.message;

      // General errors
      if (data?.type !== 'message' && message) {
        alert(message);
      }

      // Form fields issue
      if (data?.type === 'required' && message) {
        let field_key = data?.field_key ?? '';
        $wrapper.find('[name="' + field_key + '"]').closest('.c-form-row').addClass('error-required');
      }

      // Subscription error/success
      if (data?.type === 'message' && message) {
        let msgClass = 'c-event-message c-event-message--' + data?.status;
        $wrapper.html("<div class='" + msgClass + "'>" + message + "</div>");
      }
    },
    error: function(){
      $wrapper.html('Er is iets misgegaan. Probeer het later opnieuw.');
    },
    complete: function(){
      $wrapper.removeClass('ajax-overlay--active');
      $form.data('bwpSubmitting', false);
    }
  });
}

function customEventFormLoader(){
  const $loadTrigger = $(document).find('.js-event-form-load');
  let ajaxRunTimer;
  if (!$loadTrigger.length) {
    return false;
  }

  $loadTrigger.on('change', function(){
    clearTimeout(ajaxRunTimer);
    let $this = $(this);
    let event_id = $this.val();
    let $wrapper = $this.closest('.c-events-dropdown');
    let $formHolder = $wrapper.find('.js-event-form-holder');

    ajaxRunTimer = setTimeout(function(){

      $wrapper.addClass('ajax-overlay--active');

      bwpRefreshCsrfToken().always(function(){

        $.ajax({
          type: 'POST',
          url: ajax_object.ajax_url,
          data: {
            action: 'load_event_form',
            event_id: event_id,
            sequrity: ajax_object.nonce
          },
          success: function(response){
            let data = response?.data;
            let formMarkup = data?.html;
            if ((data?.status === 'success') && formMarkup) {
              $formHolder.html(formMarkup);
              customEventFormCalc();
            } else {
              $formHolder.html('');
            }
          },
          error: function(){
            $formHolder.html('Er is iets misgegaan. Probeer het later opnieuw.');
          },
          complete: function(){
            $wrapper.removeClass('ajax-overlay--active');
            customEventSubscribe();
          }
        });

      });

    }, 100);
  })

}

// Event price calculator
function customEventFormCalc() {
  const $cEventForms = $(document).find('.c-event-form');
  if ($cEventForms.length) {
    $cEventForms.each(function (i, el) {
      const $eventForm = $(el);
      const $priceDisplay = $eventForm.find('.js-event-price');
      const $hiddenInput = $eventForm.find('.js-hidden-total');

      $eventForm.on('change', '.js-qty-select', function() {
          const unitPrice = parseFloat($(this).data('price'));
          const quantity = parseInt($(this).val());

          // Calculate
          const total = unitPrice * quantity;

          // Update visible price
          if ($priceDisplay) {
            $priceDisplay.text(total.toFixed(2));
          }

          // Update the hidden input value
          if ($hiddenInput) {
            $hiddenInput.val(total.toFixed(2));
          }
        });
    });
  }
}
